import PageLayer from "@Layouts/views/PageLayer";
import TimeAndPayRatesLayer from "@DataPages/components/TimeAndPayRates/TimeAndPayRatesLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/dataPages/TimePayRates.svg";

export default function TimeAndPayRatesView() {
	return (
		<PageLayer
			title="Time and Pay Rates"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--light-blue-color)] !text-[27px]" component={Icon} />
				</Stack>
			}
		>
			<TimeAndPayRatesLayer />
		</PageLayer>
	);
}
